/**
 * Wishlist King's app-hosted "save for later" themecode (save-for-later.js)
 * removes the cart line after adding a product to the wishlist. This store
 * wants the heart in the cart to be a plain wishlist toggle instead: the
 * item stays in the cart and the button only reflects wishlist state.
 *
 * This capture-phase listener runs before the app's own click handler and
 * replaces its behavior. Remove this file if the save-for-later themecode
 * is changed to a plain toggle in the Wishlist King admin.
 */
(() => {
  if (window.wkSaveForLaterFixed) return;
  window.wkSaveForLaterFixed = true;

  document.addEventListener('click', (evt) => {
    const host = evt.target.closest && evt.target.closest('save-for-later');
    if (!host) return;

    evt.preventDefault();
    evt.stopImmediatePropagation();

    const wk = window.WishlistKing;
    const info = host.productInfo;
    if (!wk || !info) return;

    Promise.resolve(info.inWishlist ? wk.removeWishlistItem(info) : wk.addWishlistItem(info))
      .catch((error) => console.warn('Wishlist toggle failed', error)); // eslint-disable-line
  }, true);
})();
